import { __rest } from "tslib";
import React, { useRef, useEffect } from 'react';
const IntersectionVisible = (_a) => {
    var { active, className, children, options, onHide, onShow, onIntersect, Tag = 'div' } = _a, props = __rest(_a, ["active", "className", "children", "options", "onHide", "onShow", "onIntersect", "Tag"]);
    const node = useRef(null);
    let observer;
    const handleObserverUpdate = (entries) => {
        const { intersectionRect } = entries[0];
        const { top, left, bottom, right } = intersectionRect;
        const elementInViewport = [top, left, bottom, right].some(Boolean);
        if (elementInViewport && onShow) {
            onShow(entries);
        }
        else if (onHide) {
            onHide(entries);
        }
        if (onIntersect) {
            onIntersect(entries);
        }
    };
    const startObserving = () => {
        observer.observe(node.current);
    };
    const stopObserving = () => {
        observer.unobserve(node.current);
    };
    useEffect(() => {
        if ('IntersectionObserver' in window) {
            observer = new IntersectionObserver(handleObserverUpdate, options);
            if (active) {
                startObserving();
            }
            else {
                stopObserving();
            }
            return () => {
                observer.disconnect();
            };
        }
        return () => { };
    }, [options, active, onIntersect]);
    return (React.createElement(Tag, Object.assign({ className: className, ref: node }, props), children));
};
export default IntersectionVisible;
//# sourceMappingURL=IntersectionVisible.js.map